import { Form, ButtonGroup, Button, Row, Col, Card } from 'react-bootstrap';
//import { Calendar, List, Grid3x3, Clock } from 'lucide-react';
//import { Professional, ServiceFunction, ViewMode } from './types/appointment.tsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCalendarDay, faCalendarWeek, faList } from '@fortawesome/free-solid-svg-icons';



export const FilterBar = ({
  setView,
  setStartDate,
  view,
  profissionalNome
}) => {


  const statusOptions = [
    { value: 'all', label: 'Todos os Status' },
    { value: 'confirmed', label: 'Confirmado' },
    { value: 'pending', label: 'Pendente' },
    { value: 'cancelled', label: 'Cancelado' },
  ];

  const viewModes = [
    { mode: 'month', icon: <FontAwesomeIcon icon={faCalendar} />, label: 'Mês' },
    { mode: 'Week', icon: '-', label: 'Semana' },
    { mode: 'Day', icon: '-', label: 'Dia' },
    { mode: 'list', icon: '-', label: 'Lista' },
  ];


  return (
    <Card className="shadow-sm animate-fade-in">
      <Card.Body>
        <Row className="g-3 align-items-center">
          <Col xs={12} lg={8}>
            <Row className="g-2">

              <span className='bold'>{profissionalNome}</span>
              <small></small>

            </Row>
          </Col>

          <Col xs={12} lg={4}>
            <ButtonGroup className="w-100">

              {/*<Button variant={view === 'Mês' ? 'primary' : 'outline-primary'}
                size="sm"
                onClick={() => setView('month')}
                className="d-flex align-items-center justify-content-center gap-1"
              >
                <FontAwesomeIcon icon={faCalendar} />
                <span className="d-none d-sm-inline">Mês</span>
              </Button>*/}

              <Button variant={view === 'Week' ? 'primary' : 'outline-primary'}
                size="sm"
                onClick={() => setView('Week')}
                className="d-flex align-items-center justify-content-center gap-1"
              >
                <FontAwesomeIcon icon={faCalendarWeek} />
                <span className="d-none d-sm-inline">Semana</span>
              </Button>

              <Button variant={view === 'Day' ? 'primary' : 'outline-primary'}
                size="sm"
                onClick={() => setView('Day')}
                className="d-flex align-items-center justify-content-center gap-1"
              >
                <FontAwesomeIcon icon={faCalendarDay} />
                <span className="d-none d-sm-inline">Dia</span>
              </Button>
              <Button variant={view === 'Lista' ? 'primary' : 'outline-primary'}
                size="sm"
                onClick={() => setView('Lista')}
                className="d-flex align-items-center justify-content-center gap-1"
              >
                <FontAwesomeIcon icon={faList} size='xl'/>
                <span className="d-none d-sm-inline">lista</span>
              </Button>

            </ButtonGroup>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
